/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillLevelRow_skillLevel = {
    readonly id: string;
    readonly level: number | null;
    readonly description: string | null;
    readonly " $refType": "SkillLevelRow_skillLevel";
};
export type SkillLevelRow_skillLevel$data = SkillLevelRow_skillLevel;
export type SkillLevelRow_skillLevel$key = {
    readonly " $data"?: SkillLevelRow_skillLevel$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillLevelRow_skillLevel">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelRow_skillLevel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "SkillLevel"
};
(node as any).hash = 'a4dd7698bbb1179e95dd2ee513b5e6aa';
export default node;
